﻿import $ from "jquery";
import 'bootstrap-icons/font/bootstrap-icons.css';
import bootbox from 'bootbox';
import { showMessage } from "./main";

let dataTable: any;

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "productView") return;
});

function initlightbox() {
    // Inicializácia Isotope    

    let currentIndex = 0;
    const $galleryItems = $(".gallery-item");
    const $lightbox = $("#lightbox");
    const $lightboxImg = $("#lightbox-img");
    const $closeButton = $("#close");
    const $prevButton = $("#prev");
    const $nextButton = $("#next");

    // Otvorenie lightboxu
    $galleryItems.on("click", function () {
        currentIndex = $galleryItems.index(this);
        updateLightbox();
        $lightbox.fadeIn(300);
    });

    // Zatvorenie lightboxu
    $closeButton.on("click", () => {
        $lightbox.fadeOut(300);
    });

    // Navigácia medzi obrázkami
    const updateLightbox = () => {
        const newSrc = $galleryItems.eq(currentIndex).attr("src")!;
        $lightboxImg.attr("src", newSrc);
    };

    $prevButton.on("click", () => {
        currentIndex = (currentIndex - 1 + $galleryItems.length) % $galleryItems.length;
        updateLightbox();
    });

    $nextButton.on("click", () => {
        currentIndex = (currentIndex + 1) % $galleryItems.length;
        updateLightbox();
    });

    // Zatvorenie kliknutím mimo obrázka
    $lightbox.on("click", (event) => {
        if ($(event.target).is("#lightbox")) {
            $lightbox.fadeOut(300);
        }
    });
}

